import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined'
import { Box, Typography, Tooltip } from '@mui/material'
import { DatePicker as MuiDatePicker, type DatePickerProps as MuiDatePickerProps } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { zhTW } from 'date-fns/locale'
import { forwardRef, type ForwardedRef } from 'react'
import { AsteriskRed } from '../AsteriskRed/AsteriskRed'
export const DATE_FORMAT = 'yyyy-MM-dd'
export type DatePickerProps = MuiDatePickerProps<Date> & {
  required?: boolean
  label?: string
  tooltipText?: string
  isInvalid?: boolean
  errorMessage?: string
  value: Date | null
  dateFormat?: string
  placeholder?: string
}

export const DatePicker = forwardRef(function DatePicker(
  {
    label = '', required, value, tooltipText, isInvalid, errorMessage, dateFormat, placeholder, ...rest
  }: DatePickerProps,
  ref?: ForwardedRef<HTMLInputElement>,
) {
  return (
    <Box>
      {!!label && (
        <Box>
          <Typography fontSize="sm" mb={1}>
            {label || <>&nbsp;</>}
            {required && <AsteriskRed />}
            {tooltipText && (
              <Tooltip title={tooltipText}>
                <HelpOutlineOutlined />
              </Tooltip>
            )}
          </Typography>
        </Box>
      )}
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={zhTW}>
        <MuiDatePicker
          format={dateFormat}
          slotProps={{
            field: { clearable: false },
            textField: { size: 'small', error: isInvalid, helperText: `${errorMessage || ''}`, placeholder: placeholder || '選擇日期' },
          }}
          value={value}
          inputRef={ref}
          {...rest}
        />
      </LocalizationProvider>
    </Box>
  )
})
